export const getConfidenceColor = (confidence: number): string => {
	if (confidence >= 0.8) {
		return 'green';
	}
	if (confidence >= 0.5) {
		return 'yellow';
	}
	return 'red';
};
